import { createTheme, ThemeOptions } from '@mui/material/styles'
import { Primary } from '@sphinx/components-styles'

export const theme = createTheme({
  palette: {
    primary: {
      main: Primary.orange[100],
    },
  },
  components: {
    MuiSlider: {
      styleOverrides: {
        thumb: {
          backgroundColor: '#fff',
          border: `3px solid ${Primary.orange[100]}`,
          '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'unset',
          },
          '&::before': {
            display: 'none',
          },
          '&.Mui-disabled': {
            border: `3px solid ${Primary.neutral.grey4}`,
          },
        },
      },
    },
  },
} as ThemeOptions)
